import { Modal } from "antd";
import React, { useEffect } from "react";
import {
  IconTractor,
  IconUser,
  IconBuildingFactory2,
  IconTool,
} from "@tabler/icons-react";
export default function MessagePreview({
  isOpen,
  setIsOpen,
  type,
  message,
  data,
  confirmAction,
  okButtonProps,
}) {
  const itemStyles = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  };

  const dispatchSectionStyles = {
    display: "flex",
    flexDirection: "column",
    gap: "1px",
  };

  return (
    <Modal
      title={`Confirm ${type}`}
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      okText={type === "Warning" ? "Yes, send warning" : "Yes, dispatch"}
      onOk={() => {
        confirmAction(); 
        setIsOpen(false) 
      }}
      cancelText="No, review again"
      width={800}
      okButtonProps={okButtonProps}
    >
      {type === "Warning" ? (
        <div>
          <h3 strong>Sending Warning To</h3>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            {data.map((object) => {
              return object.staff_details.map((staff) => (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    background: "#f8f9fa",
                    borderRadius: "4px",
                    padding: "10px 18px",
                    width: "auto",
                  }}
                >
                  <IconUser
                    size={14}
                    style={{ marginRight: "3px" }}
                    stroke={2.5}
                  />
                  {staff.staff_name}
                </div>
              ));
            })}
          </div>
        </div>
      ) : (
        <div>
          <h3 strong>Dispatch Objects</h3>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            {data.map((object) => (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "start",
                  background: "#f8f9fa",
                  borderRadius: "4px",
                  padding: "12px",
                  gap: "20px",
                }}
              >
                {/* Crew Name */}
                {(type === "Walkway" || type === "Salting") && (
                  <div style={(dispatchSectionStyles, { width: type === "Walkway" ? "100px" :"150px" })}>
                    <span>
                      <b>Crew Name</b>
                    </span>
                    <div style={itemStyles}>{object.crew_name}</div>
                  </div>
                )}
                {/* Region */} 
                <div style={dispatchSectionStyles}>
                  <span>
                    <b>Region</b>
                  </span>
                  <div style={itemStyles}>{object.region_name}</div>
                </div>
                {/* Assigned Staff*/}
                <div style={dispatchSectionStyles}>
                  <span>
                    <b>Assigned Staff</b>
                  </span>
                  {object.staff_details.map((staff) => (
                    <div style={itemStyles}>
                      <IconUser
                        size={14}
                        style={{ marginRight: "3px" }}
                        stroke={2.5}
                      />
                      {staff.staff_name}
                    </div>
                  ))}
                </div>
                {/* Equipment */}
                {type === "Walkway" && (
                  <div style={dispatchSectionStyles}>
                    <span>
                      <b>Equipment</b>
                    </span>
                    {object.equipment_details.map((equipment) => (
                      <div style={itemStyles}>
                        <IconTool
                          size={14}
                          style={{ marginRight: "3px" }}
                          stroke={2.5}
                        />
                        {equipment.equipment_name}
                      </div>
                    ))}
                  </div>
                )}
                {/* Assigned Sites */}
                <div style={dispatchSectionStyles}>
                  <span>
                    <b>Assigned Sites</b>
                  </span>
                  {object.site_details.map((site) => (
                    <div style={itemStyles}>
                      <IconBuildingFactory2
                        size={14}
                        style={{ marginRight: "3px" }}
                        stroke={2.5}
                      />
                      {site.site_name}
                    </div>
                  ))}
                </div>
                {/* Vehicle Name */}
                <div style={dispatchSectionStyles}>
                  <span>
                    <b>Vehicle</b>
                  </span>
                  <div style={itemStyles}>
                    <IconTractor
                      size={14}
                      style={{ marginRight: "3px" }}
                      stroke={2.5}
                    />
                    {object.vehicle_name}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      <h3 strong>Message</h3>
      <div
        style={{ background: "#f8f9fa", borderRadius: "4px", padding: "12px" }}
      >
        {message}
      </div>
    </Modal>
  );
}
